import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../assets/img/logo-white.svg';
import * as AWS from 'aws-sdk';
import { configData } from '../config/systemconfigurationconstants';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import OtpVerification from './otpInput';
import lambdaConfig from "../hooks/lambdaConfig";
import UseLambdaInvocations from "../hooks/useLambdaInvocations";
// import Captcha from "demos-react-captcha";
import awsConfig from '../awsConfig';
import { Auth } from 'aws-amplify';
import { useAuth } from '../context/AuthContext';
import { useEncryption } from '../customHooks/useEncryption';
import axios from 'axios';
let refId = null;
let role = '';
const Login = () => {
    const { invokeLambda } = UseLambdaInvocations();
    // for roles and rights
    const [userRights, setUserRights] = useState();
    const [rolesAndRights, setRolesAndRights] = useState();
    const { setUser } = useAuth();
    // const { normalLogin } = useAuth();
    const [enableLogin, setEnableLogin] = useState(true);
    const [failedLogin, setFailedLogin] = useState(false);
    const [failMessage, setFailMessage] = useState('')
    const [inputType, setInputType] = useState('password');
    //Forgot Password
    const [showforgotpassword, setShowforgotpassword] = useState(false);
    const handleCloseforgotpassword = () => setShowforgotpassword(false);
    const handleShowforgotpassword = () => setShowforgotpassword(true);
    //MFA
    const [showMFA, setShowMFA] = useState(false)
    const [loginResponse, setLoginResponse] = useState("")
    //captacha
    const [showCaptcha, setShowCaptcha] = useState(false);
    const [captchaInput, setCaptchaInput] = useState("");
    const [showInvalidCaptchaMessage, setShowInvalidCaptchaMessage] = useState(false)
    // sso
    const [isLoading, setIsLoading] = useState(false);
    const { encrypt, decrypt } = useEncryption();
    const getCookie = (name) => {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) {
            return decodeURIComponent(parts.pop().split(';').shift());
        }
        return null;
    };
    const lambda = new AWS.Lambda({
        region: configData.LAMBDA_REGION,
        accessKeyId: decrypt(getCookie('ak')),
        secretAccessKey: decrypt(getCookie('sk'))
    });
    const [rid, setRid] = useState(null);
    const [userId, setUserId] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [retryCount, setRetryCount] = useState(0);
    const navigate = useNavigate();
    useEffect(() => {
        const url = new URL(window.location.href);
        const ridParam = url.searchParams.get('rid');
        if (ridParam) {
            const isKeyAvailable = localStorage.getItem('SecurityToken') !== null;
            refId = ridParam;
            setRid(ridParam);
            localStorage.setItem('rid', ridParam)
            if (isKeyAvailable) {
                oneClickurl(ridParam);
            }
        } else {
            refId = null;
            setRid(null); // or handle the absence of `rid`
            localStorage.removeItem('rid')
        }
    }, []);
    useEffect(() => {
        if (rid) {
            // Optional: perform actions that depend on `rid` being updated
            console.log("RID updated:", rid);
        }
    }, [rid]);
    // const handleLogin = async (e) => {
    //     e.preventDefault();

    //     if (!userId || !password) {
    //         setError('User ID and Password are required.');
    //         return;
    //     }

    //     const payload = {
    //         // user_name: userId,
    //         // secret: password,
    //         // Command: 'login_with_credentials',
    //         // otp: '',
    //         // email_id: ''
    //         "Command": "LOGIN_WITH_CREDENTIALS",
    //         "UserName": userId,
    //         "EmailId": userId,
    //         "Secret": password,
    //         "OTP": "",
    //         "ExternalId": "0"

    //     };

    //     const params = {
    //         FunctionName: configData.LAMBDA_FUNCTION_NAME1,
    //         Payload: JSON.stringify(payload)
    //     };

    //     // try {
    //     if (showCaptcha) {
    //         let captcha = document.getElementsByClassName('rnc-row')
    //         let captchaKey = Object.keys(captcha[0])[1];
    //         if (captcha[0][captchaKey].children[0]._owner.memoizedState.solution === captchaInput) {
    //             setShowInvalidCaptchaMessage(false)
    //             lambda.invoke(params, (err, data) => {
    //                 if (err) {
    //                     console.log(err, err.stack);
    //                 } else {
    //                     let lambdaResponse = JSON.parse(data.Payload.toString());
    //                     const parsedBody = JSON.parse(lambdaResponse.body);
    //                     let response = JSON.parse(parsedBody.Output);
    //                     console.log("login response", response);
    //                     if (response.Status === true) {
    //                         localStorage.setItem("UserMappingData", JSON.stringify(response.MappingInfo));
    //                         localStorage.setItem("UserName", response.UserName);
    //                         localStorage.setItem("FirstName", response.FirstName);
    //                         localStorage.setItem("LastName", response.LastName);
    //                         localStorage.setItem("SecurityToken", response.SecurityToken);
    //                         localStorage.setItem("Jirauseremail", response.UserEmailId);
    //                         localStorage.setItem("IsTwowyAuthEnbld", response.IsTwowyAuthEnbld);

    //                         let defaultmapping = {};
    //                         if (response.MappingInfo != null && response.MappingInfo.length > 0) defaultmapping = response.MappingInfo.find(el => el.IsDefault == true);
    //                         console.log("login.js - defaultmapping", defaultmapping);
    //                         localStorage.setItem("Role", defaultmapping.RoleName);
    //                         role = defaultmapping.RoleName;
    //                         localStorage.setItem("ExternalId", defaultmapping.ClientId);
    //                         localStorage.setItem("CurrentMapping", JSON.stringify(defaultmapping));

    //                         localStorage.setItem("AdvancedFilterUseCase", defaultmapping.UseCaseId);
    //                         localStorage.setItem("AdvancedFilterClient", defaultmapping.ClientId);

    //                         localStorage.setItem("mappingIDForUser", defaultmapping.UserMapId);

    //                         localStorage.setItem("UseCaseShortName", defaultmapping.UCSN)
    //                         localStorage.setItem("ClientShortName", defaultmapping.CSN)
    //                         // Set user in AuthContext
    //                         const userData = {
    //                             username: response.UserName,
    //                             email: response.UserEmailId,
    //                             firstName: response.FirstName,
    //                             lastName: response.LastName,
    //                             securityToken: response.SecurityToken,
    //                             role: defaultmapping.RoleName,
    //                             clientId: defaultmapping.ClientId,
    //                             useCaseId: defaultmapping.UseCaseId,
    //                             mappingInfo: response.MappingInfo,
    //                             isTwoFactorEnabled: response.IsTwowyAuthEnbld
    //                         };
    //                         setUser(userData);
    //                         if (response.IsTwowyAuthEnbld) {
    //                             setShowMFA(true)
    //                             console.log('do otp verification')
    //                         } else {
    //                             // normalLogin(userId, password);
    //                             if (rid !== null) {
    //                                 oneClickurl(rid)
    //                             } else {
    //                                 // navigate('/dashboard')
    //                                 getManageRolesAndRights();
    //                                 setRid(null)
    //                         localStorage.removeItem('rid')


    //                             }
    //                         }
    //                     }
    //                     else if (response.Status === false) {
    //                         // setShowCaptcha(true)
    //                         setShowCaptcha(false)
    //                         setEnableLogin(false)
    //                         setFailedLogin(true)
    //                         setFailMessage(response.Message)
    //                         setError(response.Message);
    //                     }
    //                 }
    //             });
    //         } else {
    //             setShowInvalidCaptchaMessage(true);
    //         };
    //         return
    //     }
    //     lambda.invoke(params, (err, data) => {
    //         if (err) {
    //             console.log(err, err.stack);
    //         } else {
    //             let lambdaResponse = JSON.parse(data.Payload.toString());
    //             const parsedBody = JSON.parse(lambdaResponse.body);
    //             let response = JSON.parse(parsedBody.Output);
    //             console.log("login response", response);
    //             if (response.Status === true) {
    //                 localStorage.setItem("UserMappingData", JSON.stringify(response.MappingInfo));
    //                 localStorage.setItem("UserName", response.UserName);
    //                 localStorage.setItem("FirstName", response.FirstName);
    //                 localStorage.setItem("LastName", response.LastName);
    //                 localStorage.setItem("SecurityToken", response.SecurityToken);
    //                 localStorage.setItem("Jirauseremail", response.UserEmailId);
    //                 localStorage.setItem("IsTwowyAuthEnbld", response.IsTwowyAuthEnbld);

    //                 let defaultmapping = {};
    //                 if (response.MappingInfo != null && response.MappingInfo.length > 0) defaultmapping = response.MappingInfo.find(el => el.IsDefault == true);
    //                 localStorage.setItem("Role", defaultmapping.RoleName);
    //                 role = defaultmapping.RoleName;
    //                 localStorage.setItem("ExternalId", defaultmapping.ClientId);
    //                 localStorage.setItem("CurrentMapping", JSON.stringify(defaultmapping));

    //                 localStorage.setItem("AdvancedFilterUseCase", defaultmapping.UseCaseId);
    //                 localStorage.setItem("AdvancedFilterClient", defaultmapping.ClientId);

    //                 localStorage.setItem("mappingIDForUser", defaultmapping.UserMapId);

    //                 localStorage.setItem("UseCaseShortName", defaultmapping.UCSN)
    //                 localStorage.setItem("ClientShortName", defaultmapping.CSN)
    //                 // Set user in AuthContext
    //                 const userData = {
    //                     username: response.UserName,
    //                     email: response.UserEmailId,
    //                     firstName: response.FirstName,
    //                     lastName: response.LastName,
    //                     securityToken: response.SecurityToken,
    //                     role: defaultmapping.RoleName,
    //                     clientId: defaultmapping.ClientId,
    //                     useCaseId: defaultmapping.UseCaseId,
    //                     mappingInfo: response.MappingInfo,
    //                     isTwoFactorEnabled: response.IsTwowyAuthEnbld
    //                 };
    //                 setUser(userData);
    //                 if (response.IsTwowyAuthEnbld) {
    //                     setLoginResponse(response)
    //                     setShowMFA(true)
    //                 } else {
    //                     // normalLogin(userId, password);
    //                     if (rid !== null) {
    //                         oneClickurl(rid)
    //                     } else {
    //                         // navigate('/dashboard')
    //                         getManageRolesAndRights();
    //                         setRid(null)
    //                         localStorage.removeItem('rid')

    //                     }
    //                 }

    //             }
    //             else if (response.Status === false) {
    //                 // setShowCaptcha(true)
    //                 setShowCaptcha(false)
    //                 setEnableLogin(false)
    //                 setFailedLogin(true)
    //                 setFailMessage(response.Message)
    //                 setError(response.Message);

    //             }
    //         }
    //     });

    // };
    const handleLogin = async (event) => {
        event.preventDefault();

        if (!userId || !password) {
            setError('User ID and Password are required.');
            return;
        }
        const data = {
            "Command": "LOGIN_WITH_CREDENTIALS",
            "UserName": userId,
            "EmailId": userId,
            "Secret": password,
            "OTP": "",
            "ExternalId": "0"
        };
        if (showCaptcha) {
            let captcha = document.getElementsByClassName('rnc-row')
            let captchaKey = Object.keys(captcha[0])[1];
            if (captcha[0][captchaKey].children[0]._owner.memoizedState.solution === captchaInput) {
                setShowInvalidCaptchaMessage(false)
                try {
                    // Make the POST request with async/await
                    const responseFunctionurl = await axios.post(configData.Function_url, data, {
                        headers: {
                            "Content-Type": "application/json",
                        },
                    });
                    console.log("Response:", responseFunctionurl.data);
                    const parsedBody = responseFunctionurl.data;
                    let response = parsedBody;
                    console.log("login response", response);
                    if (response.Status === true) {
                        // Create a new Date object for the current time
                        const now = new Date();

                        // Convert the current date to a UTC string format, as required by the 'expires' attribute
                        const utcDate = now.toUTCString();
                        document.cookie = `ak=; expires=${utcDate}; path=/;`;
                        document.cookie = `sk=; expires=${utcDate}; path=/;`;
                        let encryptedak = encrypt(response.ak)
                        let encryptedsk = encrypt(response.sk)
                        document.cookie = "ak=" + encryptedak + "; SameSite=Strict; Secure";
                        document.cookie = "sk=" + encryptedsk + "; SameSite=Strict; Secure";
                        localStorage.setItem("UserMappingData", JSON.stringify(response.MappingInfo));
                        localStorage.setItem("UserName", response.UserName);
                        localStorage.setItem("FirstName", response.FirstName);
                        localStorage.setItem("LastName", response.LastName);
                        localStorage.setItem("SecurityToken", response.SecurityToken);
                        localStorage.setItem("Jirauseremail", response.UserEmailId);
                        localStorage.setItem("IsTwowyAuthEnbld", response.IsTwowyAuthEnbld);

                        let defaultmapping = {};
                        if (response.MappingInfo != null && response.MappingInfo.length > 0) defaultmapping = response.MappingInfo.find(el => el.IsDefault == true);
                        console.log("login.js - defaultmapping", defaultmapping);
                        localStorage.setItem("Role", defaultmapping.RoleName);
                        role = defaultmapping.RoleName;
                        localStorage.setItem("ExternalId", defaultmapping.ClientId);
                        localStorage.setItem("CurrentMapping", JSON.stringify(defaultmapping));

                        localStorage.setItem("AdvancedFilterUseCase", defaultmapping.UseCaseId);
                        localStorage.setItem("AdvancedFilterClient", defaultmapping.ClientId);

                        localStorage.setItem("mappingIDForUser", defaultmapping.UserMapId);

                        localStorage.setItem("UseCaseShortName", defaultmapping.UCSN)
                        localStorage.setItem("ClientShortName", defaultmapping.CSN)
                        // Set user in AuthContext
                        const userData = {
                            username: response.UserName,
                            email: response.UserEmailId,
                            firstName: response.FirstName,
                            lastName: response.LastName,
                            securityToken: response.SecurityToken,
                            role: defaultmapping.RoleName,
                            clientId: defaultmapping.ClientId,
                            useCaseId: defaultmapping.UseCaseId,
                            mappingInfo: response.MappingInfo,
                            isTwoFactorEnabled: response.IsTwowyAuthEnbld
                        };
                        setUser(userData);
                        if (response.IsTwowyAuthEnbld) {
                            setShowMFA(true)
                            console.log('do otp verification')
                        } else {
                            // normalLogin(userId, password);
                            if (rid !== null) {
                                oneClickurl(rid)
                            } else {
                                // navigate('/dashboard')
                                getManageRolesAndRights();
                                setRid(null)
                                refId = null;
                                localStorage.removeItem('rid')


                            }
                        }
                    }
                    else if (response.Status === false) {
                        // setShowCaptcha(true)
                        setShowCaptcha(false)
                        setEnableLogin(false)
                        setFailedLogin(true)
                        setFailMessage(response.Message)
                        setError(response.Message);
                    }
                } catch (err) {
                    console.error("Error submitting form:", err);
                } finally {
                }
            } else {
                setShowInvalidCaptchaMessage(true);
            };
            return
        }
        try {
            // Make the POST request with async/await
            const responseFunctionurl = await axios.post(configData.Function_url, data, {
                headers: {
                    "Content-Type": "application/json",
                },
            });
            console.log("Response:", responseFunctionurl.data);
            const parsedBody = responseFunctionurl.data;
            let response = parsedBody;
            console.log("login response", response);
            if (response.Status === true) {
                // Create a new Date object for the current time
                const now = new Date();

                // Convert the current date to a UTC string format, as required by the 'expires' attribute
                const utcDate = now.toUTCString();
                document.cookie = `ak=; expires=${utcDate}; path=/;`;
                document.cookie = `sk=; expires=${utcDate}; path=/;`;
                let encryptedak = encrypt(response.ak)
                let encryptedsk = encrypt(response.sk)
                document.cookie = "ak=" + encryptedak + "; SameSite=Strict; Secure";
                document.cookie = "sk=" + encryptedsk + "; SameSite=Strict; Secure";
                localStorage.setItem("UserMappingData", JSON.stringify(response.MappingInfo));
                localStorage.setItem("UserName", response.UserName);
                localStorage.setItem("FirstName", response.FirstName);
                localStorage.setItem("LastName", response.LastName);
                localStorage.setItem("SecurityToken", response.SecurityToken);
                localStorage.setItem("Jirauseremail", response.UserEmailId);
                localStorage.setItem("IsTwowyAuthEnbld", response.IsTwowyAuthEnbld);

                let defaultmapping = {};
                if (response.MappingInfo != null && response.MappingInfo.length > 0) defaultmapping = response.MappingInfo.find(el => el.IsDefault == true);
                localStorage.setItem("Role", defaultmapping.RoleName);
                role = defaultmapping.RoleName;
                localStorage.setItem("ExternalId", defaultmapping.ClientId);
                localStorage.setItem("CurrentMapping", JSON.stringify(defaultmapping));

                localStorage.setItem("AdvancedFilterUseCase", defaultmapping.UseCaseId);
                localStorage.setItem("AdvancedFilterClient", defaultmapping.ClientId);

                localStorage.setItem("mappingIDForUser", defaultmapping.UserMapId);

                localStorage.setItem("UseCaseShortName", defaultmapping.UCSN)
                localStorage.setItem("ClientShortName", defaultmapping.CSN)
                // Set user in AuthContext
                const userData = {
                    username: response.UserName,
                    email: response.UserEmailId,
                    firstName: response.FirstName,
                    lastName: response.LastName,
                    securityToken: response.SecurityToken,
                    role: defaultmapping.RoleName,
                    clientId: defaultmapping.ClientId,
                    useCaseId: defaultmapping.UseCaseId,
                    mappingInfo: response.MappingInfo,
                    isTwoFactorEnabled: response.IsTwowyAuthEnbld
                };
                setUser(userData);
                if (response.IsTwowyAuthEnbld) {
                    setLoginResponse(response)
                    setShowMFA(true)
                } else {
                    // normalLogin(userId, password);
                    if (rid !== null) {
                        oneClickurl(rid)
                    } else {
                        // navigate('/dashboard')
                        getManageRolesAndRights();
                        setRid(null)
                        refId = null;
                        localStorage.removeItem('rid')

                    }
                }

            }
            else if (response.Status === false) {
                // setShowCaptcha(true)
                setShowCaptcha(false)
                setEnableLogin(false)
                setFailedLogin(true)
                setFailMessage(response.Message)
                setError(response.Message);
            }

        } catch (err) {
            console.error("Error submitting form:", err);
        } finally {
        }
        // });
    }
    const closeMFA = () => {
        setShowMFA(false)
    }
    // For Captacha
    const onCaptcha = () => {
        setCaptchaInput(document.getElementsByClassName('rnc-input')[0].value)
        setEnableLogin(true)
    }
    const onRefresh = () => {
        setCaptchaInput('')
        setEnableLogin(false);
    };
    const toggleInputType = () => {
        setInputType((prevType) => (prevType === 'password' ? 'text' : 'password'));
    };
    //Forgot Password Declaration
    const [showForgotPassValidations, setShowForgotPassValidations] = useState(false)
    const [forgotPassUserName, setForgotPassUserName] = useState("")
    const [mailSent, setMailSent] = useState(false)
    const [mailFail, setMailFail] = useState(false)
    const [forgotPassFailMessage, setForgotPassFailMessage] = useState("Please Enter Valid Username")
    const [invalidUsername, setInvalidUsername] = useState(false);
    // Forgot Password Code Start Here
    const checkUserExists = () => {

        if (forgotPassUserName === '') {
            setShowForgotPassValidations(true)
            return
        }


        else {
            const data = {
                "Command": configData.RECOVER_PASSWORD,
                "UserName": forgotPassUserName,
                "SecurityId": null,
                "SecurityToken": null,
                "EventContextId": null,
                "CallerSourceId": null,
                "CallerSourceName": null
            };
            const params = {
                FunctionName: configData.LAMBDA_FUNCTION_NAME1,
                Payload: JSON.stringify(data)
            };

            lambda.invoke(params, (err, data) => {
                if (err) {
                    console.log(err, err.stack);
                } else {
                    let lambdaResponse = JSON.parse(data.Payload.toString());
                    lambdaResponse = JSON.parse(lambdaResponse.body);
                    let responseOutput = JSON.parse(lambdaResponse.Output);
                    if (lambdaResponse.Status === true) {
                        const data = {
                            "Command": configData.SEND_EMAIL_FOR_RECOVERY,
                            "SecurityId": null,
                            "SecurityToken": null,
                            "EventContextId": null,
                            "CallerSourceId": null,
                            "CallerSourceName": null,
                            "resetLink": responseOutput.RecoveryURL,
                            "emailId": responseOutput.UserMail,
                        };
                        const params = {
                            FunctionName: configData.LAMBDA_FUNCTION_NAME,
                            Payload: JSON.stringify(data)
                        };

                        lambda.invoke(params, (err, data) => {
                            if (err) {
                                console.log(err, err.stack);
                            } else {
                                let lambdaResponse = JSON.parse(data.Payload.toString());
                                let body = JSON.parse(lambdaResponse.body)
                                if (body.Status === true) {
                                    lambdaResponse = JSON.parse(lambdaResponse.body);
                                    setMailSent(true)
                                    setMailFail(false)
                                } else {
                                    setMailFail(true)
                                    setMailSent(false)
                                }
                            }
                        });
                    }
                    else {
                        setForgotPassFailMessage('Invalid Username')
                        setInvalidUsername(true)
                    }
                }
            });
        }

    }
    //for sso
    const handleSSOLogin = async () => {
        try {
            console.log('Initiating SAML authentication...');
            // Get the value of the key you want to keep
            const valueToKeep = localStorage.getItem('rid');

            // Clear all localStorage
            localStorage.clear();

            // Restore the kept key
            if (valueToKeep !== null) {
                localStorage.setItem('rid', valueToKeep);
            }
            sessionStorage.clear();
            const identityProvider = awsConfig.Auth.oauth.identityProvider;

            console.log('AWS Config:', identityProvider);
            await Auth.federatedSignIn({
                customProvider: identityProvider,
                customState: window.crypto.randomUUID(),
            });
        } catch (error) {
            console.error('Federation error:', error);
            navigate('/error', {
                state: {
                    error: error?.message || 'Authentication failed'
                }
            });
        }
    };
    const [showOneClick, setShowOneClick] = useState(false);
    const handleCloseOneClickUrl = () => setShowOneClick(false);
    const handleShowOneClickUrl = () => setShowOneClick(true);
    // for oneclick url
    const oneClickurl = (ridParam) => {
        const data = {
            "Command": configData.GET_ONECLICK_LOANGUID,
            "RefId": ridParam,
            "SecurityId": null,
            "SecurityToken": null,
            "EventContextId": null,
            "CallerSourceId": null,
            "CallerSourceName": null
        };

        const params = {
            FunctionName: configData.LAMBDA_FUNCTION_NAME1,
            Payload: JSON.stringify(data)
        };

        lambda.invoke(params, (err, data) => {
            if (err) {
                console.log(err, err.stack);
            } else {
                let lambdaResponse = JSON.parse(data.Payload.toString());
                lambdaResponse = JSON.parse(lambdaResponse.body);
                let responseOutput = JSON.parse(lambdaResponse.Output);
                if (lambdaResponse.Status === true) {
                    // if (responseOutput.ClientId === Number(localStorage.getItem("AdvancedFilterClient")) && responseOutput.UsecaseId === Number(localStorage.getItem("AdvancedFilterUseCase"))) {
                    //     handleShowOneClickUrl();
                    // }
                    localStorage.setItem('loanGuid', responseOutput.LoanGuid)
                    getManageRolesAndRights();
                }
            }
        })
    }
    const getManageRolesAndRights = async () => {
        const data = {
            "Command": configData.GET_MANAGE_ROLES_RIGHTS,
            "SecurityId": null,
            "SecurityToken": localStorage.getItem('SecurityToken'),
            "EventContextId": null,
            "CallerSourceId": null,
            "CallerSourceName": null
        };
        const params = {
            FunctionName: configData.LAMBDA_FUNCTION_NAME1,
            Payload: JSON.stringify(data)
        };
        lambda.invoke(params, (err, data) => {
            if (err) {
                console.log(err, err.stack);
            } else {
                let lambdaResponse = JSON.parse(data.Payload.toString());
                lambdaResponse = JSON.parse(lambdaResponse.body);
                let responseOutput = JSON.parse(lambdaResponse.Output);
                if (responseOutput.Status === true) {
                    localStorage.setItem("RolesAndRights", JSON.stringify(responseOutput));
                    localStorage.setItem("UserRights", JSON.stringify(responseOutput.RolesAndRights.find(el => el.RoleName == localStorage.getItem('Role')).Rights));
                    setUserRights(responseOutput.RolesAndRights.find(el => el.RoleName == localStorage.getItem('Role')).Rights);
                    setRolesAndRights(responseOutput.RolesAndRights.find(el => el.RoleName == localStorage.getItem('Role')));
                    if (refId === null) {
                        navigate('/dashboard');
                    }
                    else {
                        navigate('/general-information')
                        setRid(null)
                        refId = null;
                        localStorage.removeItem('rid')
                    }

                }
            }
        })
    }
    return (

        <>

            <div className="vh-100">
                <div className="login-form-bx">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-lg-6 col-md-5 d-flex box-skew1">

                                <div className="inner-content align-self-center">

                                    <div className="logo" href="#">
                                        <img src={logo} alt="Logo" className="logo-img me-2" />
                                    </div>
                                    <p className="text-white mt-2" style={{ paddingLeft: "78px" }}>DecisionGenius™ is a automated and AI-driven mortgage
                                        underwriting system that empowers faster, more informed mortgage credit analyses with
                                        automated, risk-based loan underwriting technology</p>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-7 box-skew d-flex">
                                <div className="authincation-content">
                                    <div className="mb-4 text-center">
                                        <img src="src/assets/img/logo-dark.svg" alt="" className="mb-4 d-none" />
                                        <h3 className="mb-4 text-primary">Login</h3>
                                    </div>


                                    <form onSubmit={handleLogin}>

                                        <div className="row gy-3">

                                            <div className="col-xl-12">
                                                <label htmlFor="userId" className="form-label text-default">User ID</label>
                                                <input type="text" id="userId" value={userId} onChange={(e) => setUserId(e.target.value)} placeholder="Enter User ID" className="form-control form-control-sm" />
                                            </div>

                                            <div className="col-xl-12 mb-2">
                                                <label htmlFor="password" className="form-label text-default d-block" >Password</label>
                                                <div className="input-group input-group-sm">

                                                    <input type={inputType} id="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Enter Password" className="form-control form-control-sm" />

                                                    <button className="btn btn-light" type="button" id="button-addon2">{inputType === 'password' ? <i className="ri-eye-off-fill" onClick={toggleInputType}></i> : <i className="ri-eye-fill" onClick={toggleInputType}></i>}</button>
                                                </div>

                                            </div>
                                            <div className="col-xl-12 d-grid mt-2">
                                                {error && <p className="error-message">{error}</p>}
                                                {
                                                    showCaptcha &&
                                                    <>
                                                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                                                            {/* <Captcha
                                                                length={5}
                                                                onChange={onCaptcha}
                                                                onRefresh={onRefresh}
                                                                placeholder="Enter captcha"
                                                            /> */}
                                                        </div>
                                                        {/* <p className="error-message">
                                                            Please Enter Valid Credentials and Complete Captcha
                                                        </p> */}
                                                    </>
                                                }
                                                <button type="submit" className="btn btn-md btn-primary">
                                                    Login <i class="ri-arrow-right-circle-line"></i>
                                                </button>
                                                <div className="row"><div className="col-sm-12 text-end py-1">
                                                    <span style={{ cursor: "pointer" }} onClick={handleShowforgotpassword} className="text-secondary">Forgot Password
                                                        ?</span>
                                                </div></div>
                                                {showInvalidCaptchaMessage &&
                                                    <Form.Text className='text-danger'>
                                                        Invalid Captcha
                                                    </Form.Text>
                                                }
                                            </div>
                                        </div>

                                    </form>
                                    {
                                        showMFA &&
                                        <OtpVerification onClose={closeMFA} loginResponse={loginResponse} />
                                    }
                                    <button style={{ width: "100%" }}
                                        onClick={handleSSOLogin}
                                        className="btn btn-md btn-primary"
                                        disabled={isLoading}
                                    >
                                        Sign In with SSO
                                    </button>
                                    <div className="mt-4">
                                        <p className="fs-11 text-muted">
                                            Copyright © 2025. All rights reserved. | Powered by <a
                                                href="https://milosautomation.com/" target='_blank' className="text-secondary">Milos
                                                Automation</a></p>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Modal show={showforgotpassword} onHide={handleCloseforgotpassword}>
                <Modal.Header closeButton>
                    <Modal.Title>Forgot Password</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {
                        mailSent ?
                            <span>
                                A password reset link was sent. Click the link in the email to create a new password. If you do not receive an email within 5 minutes, please click the re-send email link below.
                            </span>
                            :
                            (
                                mailFail ?
                                    <span>
                                        A password reset link could not be sent. Please try again later.
                                    </span>
                                    :
                                    <Form>
                                        <Form.Group controlId="formBasicEmail">
                                            <Form.Label>Enter Username</Form.Label>
                                            <Form.Control
                                                placeholder="Enter username"
                                                onChange={(e) => [setForgotPassUserName(e.target.value), setInvalidUsername(false)]}
                                                isInvalid={showForgotPassValidations && forgotPassUserName === ''}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                username is required
                                            </Form.Control.Feedback>
                                        </Form.Group>

                                        {
                                            invalidUsername &&
                                            <Form.Text className={'text-danger'}>
                                                {forgotPassFailMessage}
                                            </Form.Text>
                                        }
                                    </Form>
                            )
                    }
                    {/* <Form>
                    <Form.Group as={Row} className="mb-1">
                        <Form.Label column sm="12">
                            Enter Username<span class="text-danger">*</span>
                        </Form.Label>
                        <Col sm="12">
                            <Form.Control size='sm'
                                type="text"
                                id="user_name"
                                placeholder='Enter Username'
                            />
                        </Col>
                    </Form.Group>
                </Form> */}
                </Modal.Body>
                <Modal.Footer>
                    <Button size='sm' variant="secondary" onClick={handleCloseforgotpassword}>
                        Close
                    </Button>
                    <Button size='sm' variant="primary" onClick={checkUserExists}>
                        {mailSent ? 'Resend Mail' : 'Send Mail'}
                    </Button>
                </Modal.Footer>
            </Modal>
            <Modal show={showOneClick} onHide={handleCloseOneClickUrl}>
                <Modal.Header closeButton>
                    <Modal.Title>Modal heading</Modal.Title>
                </Modal.Header>
                <Modal.Body>Woohoo, you are reading this text in a modal!</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseOneClickUrl}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={handleCloseOneClickUrl}>
                        Save Changes
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default Login;